var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',[_c('v-card-title',[_vm._v(" SISTEMAS "),_c('v-spacer'),_c('SistemaModal',{on:{"saved":function($event){_vm.params = {}}}})],1),_c('v-card-text',[_c('SistemaList',{attrs:{"params":_vm.params}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }